<template>
  <el-dialog
    :title="`扫码预览(${option.tagIndex + 1}/${max + 1})`"
    :visible.sync="visible"
    width="850px"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <div
      v-loading="loading"
      class="page-wrap">
      <el-button
        type="primary"
        style="margin-right:5px;"
        icon="el-icon-d-arrow-left"
        circle
        :disabled="option.tagIndex === 0"
        @click="prev"></el-button>
      <iframe
        :src="url"
        style="width:375px;height:667px;border: 1px solid #eee"
        frameborder="0"></iframe>
      <el-button
        type="primary"
        style="margin-left:5px;"
        icon="el-icon-d-arrow-right"
        circle
        :disabled="option.tagIndex === max"
        @click="next"></el-button>
      <el-form
        v-loading="loading"
        class="qr-form"
        label-width="85px">
        <el-form-item label="链接：">
          {{ url }}
        </el-form-item>
        <el-form-item label="标签序号：">
          {{ formatedTagNo }}
        </el-form-item>
        <el-form-item label="二维码：">
          <create-qr-code ref="qr" />
        </el-form-item>
      </el-form>
    </div>

    <template
      slot="footer"
      class="dialog-footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import CreateQrCode from '@/components/public/create-qr-code.vue'
export default {
  name: 'BatchQrCodeModal',
  components: { CreateQrCode },
  data() {
    return {
      loading: false,
      visible: false,
      min: 0,
      max: 10000,
      url: '',
      formatedTagNo: '',
      option: {
        vendorId: null,
        batchId: null,
        tagIndex: 0
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.option.vendorId = null
      this.option.batchId = null
      this.option.tagIndex = 0
      this.formatedTagNo = ''
      this.url = ''
    },
    fetchUrl(postData, cb) {
      this.loading = true
      this.$store.dispatch('batch/getbatchtagscanurl', {
        payload: postData,
        success: (res) => {
          console.log(res)
          cb(res.data.tagScanUrl, res.data.formatedTagNo)
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    next() {
      console.log('next', this.option.tagIndex)
      this.fetchUrl({
        ...this.option,
        tagIndex: this.option.tagIndex + 1
      }, (url, formatedTagNo) => {
        this.option.tagIndex = this.option.tagIndex + 1
        this.url = url
        this.formatedTagNo = formatedTagNo
        this.$refs.qr.init(url)
      })
    },
    prev() {
      console.log('prev', this.option.tagIndex)
      this.fetchUrl({
        ...this.option,
        tagIndex: this.option.tagIndex - 1
      }, (url, formatedTagNo) => {
        this.option.tagIndex = this.option.tagIndex - 1
        this.url = url
        this.formatedTagNo = formatedTagNo
        this.$refs.qr.init(url)
      })
    },
    init(row) {
      this.fetchUrl({
        vendorId: row.vendorId,
        batchId: row.batchId,
        tagIndex: 0
      }, (url, formatedTagNo) => {
        this.toggleModal(true)
        this.max = row.tagCount - 1
        this.option.vendorId = row.vendorId
        this.option.batchId = row.batchId
        this.option.tagIndex = 0
        this.formatedTagNo = formatedTagNo
        this.url = url
        setTimeout(() => {
          this.$refs.qr.init(url)
        }, 20)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-wrap {
  display: flex;
  align-items: center;
}

.qr-form {
  align-self: flex-start;
  padding-left: 5px;
  margin-left: 5px;
  border-left: 1px solid #eee;
  flex: 1;
  height: 667px;
}
</style>
